import AppCalendarProviders from "./Providers";
import React from "react";
import AppCalendarContent from "./Content";
import AppCalendarModals from "./Modals";


export default function AppCalendar({ calendarData= {}, openDetailsModal = () => {}, externalEvents = [], dates = [], dateRange, startDate, showLocationData = false }) {

    return <AppCalendarProviders>
        <AppCalendarContent
            calendarData={calendarData}
            dateRange={dateRange}
            startDate={startDate}
            openDetailsModal={openDetailsModal}
            externalEvents={externalEvents}
            dates={dates}
            showLocationData={showLocationData}
        />
        <AppCalendarModals />
    </AppCalendarProviders>
}